import React, { useState } from "react";
import { Worker, Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { rotatePlugin } from "@react-pdf-viewer/rotate";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import jumpToPagePlugin from "./jumpToPagePlugin";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/zoom/lib/styles/index.css";

import pageIcon from "@assets/icons/page-icon.svg";
import styles from "./PDFViewer.module.css";

function PDFViewer({
  pdfUrl,
  title,
  style,
  pageMapping,
}: {
  pdfUrl: string;
  title?: string;
  style?: React.CSSProperties;
  pageMapping?: number[];
}) {
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const zoomPluginInstance = zoomPlugin();
  const rotatePluginInstance = rotatePlugin();
  const jumpToPagePluginInstance = jumpToPagePlugin();

  const { ZoomIn, ZoomOut, ZoomPopover } = zoomPluginInstance;
  const { RotateBackwardButton, RotateForwardButton } = rotatePluginInstance;
  const { jumpToPage } = jumpToPagePluginInstance;

  return (
    <div className={styles.container}>
      <div className={styles.heading}>{title}</div>

      <div className={styles.contentWrapper}>
        <div className={styles.pdfContainer} style={style}>
          <div className={styles.pageIndicator}>
            <img src={pageIcon} alt="Page Icon" />
            {currentPage < 9 ? `0${currentPage + 1}` : currentPage + 1} of{" "}
            {totalPages} pages
          </div>
          <div className={styles.zoomControls}>
            <ZoomOut />
            <ZoomPopover />
            <ZoomIn />
            <RotateBackwardButton />
            <RotateForwardButton />
          </div>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <Viewer
              fileUrl={pdfUrl}
              plugins={[zoomPluginInstance, rotatePluginInstance, jumpToPagePluginInstance]}
              onPageChange={(e) => setCurrentPage(e.currentPage)}
              onDocumentLoad={(e) => {
                setTotalPages(e.doc.numPages);

                if (pageMapping?.length) {
                  const pageToOpen = pageMapping[0];
                  if (
                    pageToOpen > 0 &&
                    pageToOpen <= e.doc.numPages
                  ) {
                    jumpToPage(pageToOpen - 1);
                  }
                }
              }}
              renderError={()=>(
                <div className={styles.errorState}>
                  <p>Unable to load PDF</p>
                  <small>Please check the file or try again later.</small>
                </div>
              )}
              defaultScale={SpecialZoomLevel.PageWidth}
            />
          </Worker>
        </div>
        <div className={styles.sideBorder}></div>
      </div>
    </div>
  );
}

export default PDFViewer;